import { ChangeDetectionStrategy, Component, Input,OnInit } from '@angular/core';
import { SiteContext, SiteContextActions, StateWithClientAuth } from '@spartacus/core';
import { ICON_TYPE,SiteContextComponentService,SiteContextType } from '@spartacus/storefront';
// import { SiteContextComponentService } from '@spartacus/storefront/cms-components/misc/site-context-selector/site-context-component.service';
// import { SiteContextType } from '@spartacus/storefront/cms-components/misc/site-context-selector/site-context.model';
import { Observable } from 'rxjs';
import { LanguageService } from '@spartacus/core';
import { Store } from '@ngrx/store';
import { NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-custom-language',
    templateUrl: './custom-language.component.html',
    styleUrls: ['./custom-language.component.scss'],
    imports: [NgFor, FormsModule]
})
export class CustomLanguageComponent implements OnInit {
  siteContextService: SiteContext<any>;
  iconTypes = ICON_TYPE;
  items:any=[];
  /**
   * the context type can be set as an input. If the context is
   * not given, the context will be loaded from the backend.
   */
  @Input() context: SiteContextType;
  activeItem: any;
  constructor( protected store: Store<StateWithClientAuth>,private componentService: SiteContextComponentService, private languageService: LanguageService) {
    // alert("calling custom component");
  }
  ngOnInit(): void {
    this.items=[{"label": "English", "value":"en"},{"label":" 中文 ", "value":"zh"}]
    // this.items=[{"label":"English","value":"en","isocode":"en" },{"label":"Chinese","value":"zh","isocode":"zh" }];
    this.languageService.getActive().subscribe(resp=>{
      this.activeItem = resp;
    });
  }

  get items$(): Observable<any> {
    // return this.componentService.getItems(this.context);
    return this.languageService.getAll();
  }

  get activeItem$(): Observable<string> {
    // return this.componentService.getActiveItem(this.context);
    return this.languageService.getActive();
  }

  set active(value: string) {
    // this.componentService.setActive(value, this.context);
    this.languageService.setActive(value);
  }

  get label$(): Observable<any> {
    // return this.componentService.getLabel(this.context);
    return ;
  }
  changeLang(event) {
    this.languageService.setActive(event.target.value);
    this.store.dispatch(new SiteContextActions.SetActiveLanguage(event.target.value));
    this.languageService.getActive().subscribe(resp=>{
      this.activeItem = resp;
     // this.languageService.setActive(this.activeItem);
    });
    //var e = document.getElementById("selectedAccount");
    // var value = e.nodeValue;
    // alert(value)
    // var value = e?.options[e.selectedIndex].text;
    // alert(document.getElementById('selectedAccount').TEXT_NODE);
    // var selectElement = document.querySelector('#selectedAccount');
    // var output = selectElement.;
    // document.querySelector('.output').textContent = output;
    // var accountName = document.getElementById('selectedAccount').options[document.getElementById('selectedAccount').selectedIndex].text;
   // var accountName = (document.getElementById('selectedAccount') as HTMLSelectElement).options[(document.getElementById('selectedAccount') as HTMLSelectElement).selectedIndex].text;
    // var text = e.options[e.selectedIndex].text;
    //sessionStorage.setItem('selectedAccount', accountName);
    localStorage.setItem('selectorPref', 'true');
  }
}


